export default __webpack_public_path__ + "static/media/nadker.de85823d.png";